import { cn } from "@/lib/utils";

/**
 * Whole picture inside a fixed frame (markup review P27-a, launch review F5/F6).
 *
 * Same technique as the gallery video cards (GallerySections.tsx VideoThumb):
 * the picture is shown uncropped (object-contain) and a soft blurred copy of the
 * same picture fills the empty sides. Both layers use the same src, so the
 * browser makes one request.
 *
 * Render it as the only image inside a frame that already has a fixed size or
 * aspect ratio plus `relative overflow-hidden`; the frame keeps its shape, so
 * there is no layout shift. The blurred layer is decorative (empty alt,
 * aria-hidden). Overlays placed after this component (badges) paint on top.
 */
export function FramedPicture({
  src,
  alt,
  className,
  sizes,
}: {
  src: string;
  alt: string;
  /** Extra classes for the visible picture (e.g. a group-hover transition). */
  className?: string;
  sizes?: string;
}) {
  return (
    <>
      <img
        src={src}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full scale-110 object-cover opacity-60 blur-xl"
      />
      <img
        src={src}
        alt={alt}
        loading="lazy"
        sizes={sizes}
        className={cn("relative h-full w-full object-contain", className)}
      />
    </>
  );
}
